angular.module('app.filter', [])

.filter('thousandSuffix', function () {
    return function (input, decimals) {
        var exp, rounded,
        suffixes = ['K', 'M', 'G', 'T', 'P', 'E'];

        if(window.isNaN(input)) {
            return null;
        }

        if(input < 1000) {
            return Math.round(input);
        }

        exp = Math.floor(Math.log(input) / Math.log(1000));

        return (input / Math.pow(1000, exp)).toFixed(decimals) + suffixes[exp - 1];
    };
})

.filter('percentage', ['$filter', function ($filter) {
    return function (input, decimals) {
        return $filter('number')(input * 100, decimals) + '%';
    };
}]);